<section class="landing-page container-fluid p-5">
  <div class="h-100">
    <amplify-authenticator initialState="signIn">
      <ng-template amplifySlot="authenticated">
      </ng-template>
    </amplify-authenticator>
  </div>
</section>
